<template>
  <header class="header">
    <div class="header__content">
      <a class="header__wrapper-logo" href="/">
        <img
          src="@/assets/media/logo-brighter.png"
          srcset="@/assets/media/logo-brighter@2x.png 2x"
          class="header__logo"
        />
      </a>

      <div class="header__items">
        <Item :link="{ name: 'devices' }">
          <template #icon>
            <img src="@/assets/img/icons/header/device.svg" alt="Devices" />
          </template>
          Devices
        </Item>
        <Item :link="{ name: 'samples' }">
          <template #icon>
            <img src="@/assets/img/icons/header/sample.svg" alt="Samples" />
          </template>
          Samples
        </Item>
        <Item :link="{ name: 'sequences' }">
          <template #icon>
            <img src="@/assets/img/icons/header/sequence.svg" alt="Sequences" />
          </template>
          Sequences
        </Item>
        <Item :link="{ name: 'methods' }">
          <template #icon>
            <img src="@/assets/img/icons/header/method.svg" alt="Methods" />
          </template>
          Methods
        </Item>
        <Item :link="{ name: 'columns' }">
          <template #icon>
            <img src="@/assets/img/icons/header/column.svg" alt="Columns" />
          </template>
          Columns
        </Item>
        <Item :link="{ name: 'postprocessingTemplates' }">
          <template #icon>
            <img
              src="@/assets/img/icons/header/postprocessing.svg"
              alt="Postprocessing templates"
            />
          </template>
          Postprocessings
        </Item>
        <Item :link="{ name: 'account' }">
          <template #icon>
            <img src="@/assets/img/icons/header/user.svg" alt="Account" />
          </template>
          Account
        </Item>
      </div>
    </div>
  </header>
</template>

<script>
  import Item from './private/Item';

  export default {
    name: 'Header',

    components: { Item },
  };
</script>

<style lang="scss" scoped>
  .header {
    max-width: 100vw;
    overflow: hidden;
    z-index: 2;
    position: relative;
    height: 60px;
    background-color: $color-bg-second;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15), 0 3px 20px 0 rgba(0, 0, 0, 0.12);

    @media (max-width: 400px) {
      height: 48px;
    }

    @media print {
      display: none;
    }

    &__content {
      display: flex;
      width: 100%;
      max-width: 900px;
      margin: auto;
      background-color: $color-bg-second;

      @media (max-width: 400px) {
        max-width: 100vw;
        overflow-x: hidden;
      }
    }

    &__wrapper-logo {
      flex: none;
      height: 60px;
      width: 60px;
      padding: 5px;
      margin: 0;

      &:hover {
        background: $color-bg-transparent--hover;
      }

      &:active {
        background: $color-bg-transparent--active;
      }

      @media (max-width: 400px) {
        height: 48px;
        width: 48px;
        padding: 3px;
      }
    }

    &__logo {
      flex-wrap: nowrap;
      height: 50px;
      padding: 0;
      margin: 0;

      @media (max-width: 400px) {
        height: 42px;
      }
    }

    &__items {
      display: flex;
      margin-left: auto;

      @media (max-width: 550px) {
        flex: 1;
        justify-content: space-around;
        overflow-x: hidden;
      }
    }
  }
</style>
